import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { Known } from '../models/known.model';

@Injectable({
  providedIn: 'root'
})
export class KnownService {

    private apiURL : string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/known';

    }

    get(): any {

        const url = this.apiURL;
        return this.http.get<Known[]>(url);

    }

}
